
export default {
  name: "uploadedDocuments",

  data: () => ({
    toDelete: [],
  }),

  methods: {
    isToDelete(id) {
      if (this.toDelete.find((i) => i == id)) {
        return "isDeleting";
      } else {
        return "isOk";
      }
    },

    deleteFile(id) {
      if (this.toDelete.find((i) => i == id)) {
        let index = this.toDelete.indexOf(id);
        this.toDelete.splice(index, 1);
      } else {
        this.toDelete.push(id);
      }
      this.$emit("change", [...this.toDelete]);
    },

    // >>> NOVO: só considera imagem com extensões jpg/jpeg/png/gif/webp/bmp/svg
    isImageUrl(url) {
      if (!url) return false;
      try {
        const u = new URL(url, window.location.origin);
        const path = (u.pathname || "").toLowerCase();
        return /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(path);
      } catch {
        return false;
      }
    },

    // >>> NOVO: duplo clique abre a imagem
    openItem(url) {
      if (!url) return;
      try {
        const w = window.open(url, "_blank");
        if (!w) window.location.href = url; // fallback se popup bloqueado
      } catch (e) {
        window.location.href = url;
      }
    },
  },

  props: {
    documents: Array,
  },
};
